import { app } from '../../app.module'
app.component('userInfo', {
  bindings: {
    username: '=',
    pictureUrl: '=',
  },
  template: require('./user-info.pug')(),
})
